import "core-js/modules/web.dom.iterable";
import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { postAction } from '@/api/manage';
export default {
  name: 'JImportModal',
  props: {
    url: {
      type: String,
      default: '',
      required: false
    }
  },
  data: function data() {
    return {
      visible: false,
      uploading: false,
      fileList: [],
      uploadAction: ''
    };
  },
  watch: {
    url: function url(val) {
      if (val) {
        this.uploadAction = window._CONFIG['domianURL'] + val;
      }
    }
  },
  created: function created() {
    this.uploadAction = window._CONFIG['domianURL'] + this.url;
  },
  methods: {
    handleClose: function handleClose() {
      this.visible = false;
    },
    show: function show() {
      this.fileList = [];
      this.uploading = false;
      this.visible = true;
    },
    handleRemove: function handleRemove(file) {
      var index = this.fileList.indexOf(file);
      var newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    beforeUpload: function beforeUpload(file) {
      this.fileList = [].concat(_toConsumableArray(this.fileList), [file]);
      return false;
    },
    handleImport: function handleImport() {
      var _this = this;

      var fileList = this.fileList;
      var formData = new FormData();
      fileList.forEach(function (file) {
        formData.append('files[]', file);
      });
      this.uploading = true;
      postAction(this.uploadAction, formData).then(function (res) {
        _this.uploading = false;

        if (res.success) {
          _this.$notification.success({
            message: res.message
          });

          _this.visible = false;

          _this.$emit('ok');
        } else {
          _this.$notification.warning({
            message: res.message
          });
        }
      });
    }
  }
};